// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BodyAddResourceForTaskTasksTaskIdResourcesPostLinkUrl } from './bodyAddResourceForTaskTasksTaskIdResourcesPostLinkUrl';
import type { BodyAddResourceForTaskTasksTaskIdResourcesPostFile } from './bodyAddResourceForTaskTasksTaskIdResourcesPostFile';

export interface BodyAddResourceForTaskTasksTaskIdResourcesPost {
  link_url?: BodyAddResourceForTaskTasksTaskIdResourcesPostLinkUrl;
  file?: BodyAddResourceForTaskTasksTaskIdResourcesPostFile;
}
